import { Component } from '@angular/core';

@Component({
  selector: 'app-corporate-readers-view',
  templateUrl: './corporate-readers-view.component.html',
  styleUrl: './corporate-readers-view.component.scss'
})
export class CorporateReadersViewComponent {

}
